import "../Common/css/tickets.css"
import "../Common/css/styles.css"
import "../Common/css/user.css"
import TableToolbar from "src/Components/TableToolbar"
import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { getAllTickets, markTicketAsAddressed } from "src/Services/user_api";
import { Dialog, Grid, IconButton, Menu, MenuItem } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import Dialogbox from "src/Components/Dialogbox";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import { set } from "date-fns";

const ITEMS_PER_PAGE = 5;

export default function AdminTickets() {
    const [searchTerm, setSearchTerm] = React.useState("");
    const [openModal, setOpenModal] = React.useState(false);
    const [tickets, setTickets] = React.useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedTicket, setSelectedTicket] = React.useState<any>(null);
    const [viewDialogOpen, setViewDialogOpen] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [alertType, setAlertType] = React.useState<"success" | "error" | "warning">("success");
    const [alertDescription, setAlertDescription] = React.useState("");
    const token = sessionStorage.getItem("token") || "";

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>, ticket: any) => {
        setAnchorEl(event.currentTarget);
        //console.log(`Selected ticket: ${ticket.id}`);

        setSelectedTicket(ticket);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleGetTickets = async () => {
        try {
            const tickets = await getAllTickets(token);
            setTickets(tickets);
        } catch (error) {
            console.error("Error fetching tickets:", error);
        }
    };

    useEffect(() => {
        handleGetTickets();
    }, []);

    const filteredTickets = tickets.filter((ticket) =>
        ticket.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.studentName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedTickets = filteredTickets.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    )

    const totalPages = Math.ceil(filteredTickets.length / ITEMS_PER_PAGE);

    const handleUpdate = async () => {
        setIsLoading(true);
        const body = {
            id: selectedTicket.id,
            studentId: selectedTicket.studentId,
            title: selectedTicket.title,
            description: selectedTicket.description,
            ticketType: selectedTicket.ticketType,
            isAddressed: true
        }

        try {
            await markTicketAsAddressed(token, body);
            showAlert("Ticket marked as addressed successfully.", "success");
            setIsLoading(false);
            handleGetTickets();
        } catch (error) {
            showAlert("Failed to mark ticket as addressed.", "error");
            setIsLoading(false);
        } finally {
            setIsOpen (false)
        }
    }

    return (
        <div className="comman-outer">
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Spinner isLoading={isLoading} />
            <Dialogbox
                open={isOpen}
                title="Address Ticket"
                content="Are you sure you want to mark this ticket as addressed?"
                agreeButtonText="Yes"
                disagreeButtonText="No"
                onAgree={handleUpdate}
                onDisagree={() => setIsOpen(false)}
                onClose={() => setIsOpen(false)}
            />
            <TableToolbar
                title="Tickets List"
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isButton={false}
                buttonText=""
                onButtonClick={() => setOpenModal(true)}
                buttonIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
            />
            <div className="space-bar"></div>

            {paginatedTickets.length > 0 ? paginatedTickets.map((ticket) => (

                <div className="card-outer" key={ticket.id}>
                    <div className="card-outer1">
                        <p className="t-card">{ticket.ticketType === 1 ? "Operational Ticket" : "Technical Ticket"}</p>
                        <p className="t-card">{ticket.studentName}</p>
                        <p className="t-card">{ticket.studentEmail}</p>
                        <p className="t-card" style={{ color: ticket.isAddressed ? "green" : "yellow" }}>{ticket.isAddressed ? "Completed" : "Pending (Not addressed yet)"}</p>
                    </div>
                    <IconButton onClick={(e) => handleMenuClick(e, ticket)}>
                        <MoreVert style={{ color: "white" }} />
                    </IconButton>
                </div>
            )) : (
                <div style={{ justifyContent: "center", alignItems: "center" }} className="card-outer">No tickets found.</div>
            )}

            <div className="pagination-footer">
                <span style={{ fontSize: "13px" }}>
                    Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1} -{" "}
                    {Math.min(currentPage * ITEMS_PER_PAGE, filteredTickets.length)} of{" "}
                    {filteredTickets.length}
                </span>
                <div className="pagination-buttons">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                    >
                        Prev
                    </button>
                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i}
                            onClick={() => setCurrentPage(i + 1)}
                            className={currentPage === i + 1 ? "active" : ""}
                        >
                            {i + 1}
                        </button>
                    ))}
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>

            <Dialog
                open={viewDialogOpen}
                onClose={() => setViewDialogOpen(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { backgroundColor: "#c6c2c2e3", color: "white", paddingBottom: 2, borderRadius: 2, boxShadow: 24, border: "1px solid #ffffffff" },
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "1px solid #555", backgroundColor: "#393939", padding: "25px 16px" }}>
                    <h3>Ticket Details</h3>
                </div>

                <Grid container spacing={2} style={{ padding: "25px 16px", color: "white" }} className="form-grid">
                    <Grid item xs={12} sm={6}>
                        <strong>Title:</strong> {selectedTicket?.title}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Type:</strong> {selectedTicket?.ticketType === 1 ? "Operational Ticket" : "Technical Ticket"}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Raised By:</strong> {selectedTicket?.studentName}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Email:</strong> {selectedTicket?.studentEmail}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Raised Time:</strong> {selectedTicket?.lastSyncedTime.split("T")[0]} {selectedTicket?.lastSyncedTime.split("T")[1].split(".")[0]}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Status:</strong> {selectedTicket?.isAddressed ? "Completed" : "Not Addressed Yet"}
                    </Grid>
                    <Grid item xs={12}>
                        <strong>Description:</strong> {selectedTicket?.description}
                    </Grid>
                </Grid>
            </Dialog>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem onClick={() => {
                    setViewDialogOpen(true);
                    handleMenuClose();
                }}>View</MenuItem>
                {selectedTicket && !selectedTicket.isAddressed && (
                    <MenuItem onClick={() => {
                        setIsOpen(true);
                        handleMenuClose();
                    }}>Complete</MenuItem>
                )}
            </Menu>
        </div>

    )
}